import { Navigate } from 'react-router-dom';
import { useKiosk } from '../../context/KioskContext/KioskContext';

export function RequireAttendee({ children }) {
  const { attendee } = useKiosk();
  return attendee ? children : <Navigate to="/kiosk" replace />;
}